import React from 'react';
import { Bot } from 'lucide-react';
import { cn } from '../../../ui';
import DashCard from '../shared/DashCard';
import { usageBars } from '../studentHomeRules';

const HOUR_MARKS = ['12AM', '6AM', '12PM', '6PM', '12AM'];

const AiInsightCard = ({ insight }) => {
  const { hasData, bars } = usageBars(insight);
  return (
    <DashCard title="AI Insight" icon={<Bot size={18} aria-hidden="true" className="tw-text-primary" />}>
      <p className="tw-m-0 tw-text-[0.8125rem] tw-leading-snug tw-text-content-muted">
        {hasData ? (
          <>
            You are most active in the
            <strong className="tw-mt-0.5 tw-block tw-text-sm tw-font-medium tw-text-content">{insight.activeWindow}</strong>
          </>
        ) : (
          "Use Learn with AI, Mock Interviews, or AIvo — we'll show your usage patterns here."
        )}
      </p>
      <div
        role="img"
        aria-label={hasData ? `Your AI activity by hour peaks in the ${insight.activeWindow}.` : 'No AI activity yet.'}
        className="tw-mt-3"
      >
        <div className="tw-flex tw-h-20 tw-items-end tw-justify-between tw-gap-px" aria-hidden="true">
          {bars.map((bar) => (
            <span
              key={bar.hour}
              style={{ height: `${bar.height}%` }}
              className={cn('tw-w-full tw-max-w-[8px] tw-rounded-full', hasData && bar.peak ? 'tw-bg-primary' : 'tw-bg-primary/15')}
            />
          ))}
        </div>
        <div className="tw-mt-1.5 tw-flex tw-justify-between tw-text-[0.625rem] tw-font-medium tw-text-content-subtle" aria-hidden="true">
          {HOUR_MARKS.map((mark, i) => <span key={`${mark}-${i}`}>{mark}</span>)}
        </div>
      </div>
    </DashCard>
  );
};

export default AiInsightCard;
